import { Typography } from "@foodpilot/foods";
import { Stack, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLanguage } from "src/context/LanguageProvider";
import { formatNumberByType } from "src/utils/formatting";
import { FieldStartingValue } from "./fieldStartingValues";

type StartingValuesProps = {
    year: string | undefined;
    values: FieldStartingValue[];
};

export const StartingValues = ({ year, values }: StartingValuesProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { currentLanguage } = useLanguage();

    if (values.length === 0) {
        return null;
    }

    const labelColor = theme.custom.grey[2500];

    return (
        <Stack gap={theme.spacing(0.5)}>
            {year !== undefined && (
                <Typography variant="small-regular" sx={{ color: labelColor }}>
                    {t("my_action_plan.starting_values.title", "Your values in {{year}}", { year })}
                </Typography>
            )}
            {values.map(({ propertyId, label, value, unit }) => {
                const formattedValue = formatNumberByType(value, unit, currentLanguage);

                return (
                    <Typography key={propertyId} variant="small-regular" sx={{ color: labelColor }}>
                        {t("my_action_plan.starting_values.label", "{{label}}:", { label })}{" "}
                        <Typography component="span" variant="small-semibold">
                            {unit === undefined ? formattedValue : `${formattedValue}\u00A0${unit}`}
                        </Typography>
                    </Typography>
                );
            })}
        </Stack>
    );
};
